import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authGoogleSession } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    // Clean hash from URL right away
    window.history.replaceState(null, '', window.location.pathname + window.location.search);

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        await authGoogleSession(sessionId);
        await refresh();
        navigate('/admin', { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || 'Login failed. Please contact the administrator.';
        toast({ title: 'Login blocked', description: detail, variant: 'destructive' });
        navigate('/login', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#e2ede6] text-[#0b1a2e]/70">
      <Loader2 className="w-6 h-6 animate-spin mr-3" /> Signing you in…
    </div>
  );
};

export default AuthCallback;
